import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ShieldIcon, SunIcon, UsersIcon, DollarSignIcon, MoonIcon } from 'lucide-react';
const benefits = [{
  icon: SunIcon,
  title: 'Blindaje Matutino',
  description: 'Oraciones de sellamiento para que nada te toque mientras estás fuera.'
}, {
  icon: UsersIcon,
  title: 'Manto sobre tus Hijos',
  description: 'Salmos específicos para que los ángeles los escolten a la escuela o al trabajo.'
}, {
  icon: DollarSignIcon,
  title: 'Paz Financiera',
  description: 'Decretos de provisión para que el dinero rinda y las puertas se abran.'
}, {
  icon: MoonIcon,
  title: 'Sueño Reparador',
  description: 'Oraciones para soltar la ansiedad y dormir como hace años no lo haces.'
}];
export function SolutionSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-12 sm:py-16 px-4 sm:px-6" style={{
    background: 'linear-gradient(180deg, #0D1F3C 0%, #1B3A6B 50%, #0D1F3C 100%)'
  }} data-id="element-96">
      <div className="max-w-4xl mx-auto" data-id="element-97">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} className="text-center mb-4" data-id="element-98">
          <p className="font-cinzel text-gold-warm tracking-widest uppercase text-xs mb-2" data-id="element-99">
            Presentamos
          </p>
          <h2 className="font-cinzel font-black text-3xl sm:text-4xl md:text-6xl mb-2" style={{
          color: '#FFF8E7'
        }} data-id="element-100">
            ESCUDO DE FE
          </h2>
          <p className="font-cinzel text-gold-light text-base sm:text-xl md:text-2xl mb-4" data-id="element-101">
            Tu Kit Digital de Oración y Protección Familiar
          </p>
          <div className="divider-gold mx-auto mb-6" style={{
          width: '180px'
        }} data-id="element-102" />
        </motion.div>

        {/* Description */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="text-center mb-10" data-id="element-103">
          <p className="font-lato text-base sm:text-lg leading-relaxed max-w-2xl mx-auto" style={{
          color: 'rgba(255,248,231,0.85)'
        }} data-id="element-104">
            Este no es solo un libro de oraciones. Es un{' '}
            <strong className="text-gold-light" data-id="element-105">
              plan de acción espiritual de 51 páginas
            </strong>{' '}
            diseñado para la mujer y el hombre de hoy que no tiene horas para
            rezar, pero que necesita{' '}
            <strong className="text-gold-light" data-id="element-106">
              resultados urgentes del Cielo.
            </strong>
          </p>
        </motion.div>

        {/* Benefits grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10" data-id="element-107">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.6,
            delay: 0.3 + index * 0.12
          }} className="flex items-start gap-4 p-4 sm:p-5 rounded-xl" style={{
            background: 'rgba(10,22,40,0.6)',
            border: '1px solid rgba(201,168,76,0.3)'
          }} data-id="element-108">
                <div className="flex-shrink-0 w-11 h-11 rounded-full flex items-center justify-center" style={{
              background: 'linear-gradient(135deg, rgba(201,168,76,0.2) 0%, rgba(240,208,128,0.1) 100%)',
              border: '2px solid rgba(201,168,76,0.5)'
            }} data-id="element-109">
                  <Icon size={20} className="text-gold-light" data-id="element-110" />
                </div>
                <div data-id="element-111">
                  <h3 className="font-cinzel font-bold text-sm sm:text-base mb-1 text-gold-light" data-id="element-112">
                    {benefit.title}
                  </h3>
                  <p className="font-lato text-sm leading-relaxed" style={{
                color: 'rgba(255,248,231,0.85)'
              }} data-id="element-113">
                    {benefit.description}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>

        {/* Book image centered */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="flex justify-center" data-id="element-114">
          <div className="relative" data-id="element-115">
            <div className="absolute inset-0 rounded-xl blur-3xl" style={{
            background: 'rgba(201,168,76,0.2)',
            transform: 'scale(0.85) translateY(15px)'
          }} data-id="element-116" />
            <img src="https://cdn.magicpatterns.com/uploads/wymb9NwAMjTpTr6jfXwsX9/ART_ESCUDO_DE_FE.png" alt="Escudo de Fe - Manual Completo" className="relative z-10 rounded-xl" style={{
            maxWidth: '220px',
            width: '100%'
          }} data-id="element-117" />
          </div>
        </motion.div>
      </div>
    </section>;
}